// Customer support web page. Replaces the previous support email contact
// (matkat@tim.travel / matkat@imt.fi), which is being decommissioned.
export const SUPPORT_URL = 'https://apu.imt.fi';

// Visible text for the support link (the URL without the scheme).
export const SUPPORT_URL_LABEL = 'apu.imt.fi';
